<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-breadcrumbs :items="breadcrumbs">
                        <template v-slot:divider>
                            <v-icon>chevron_right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="12" md="6">
                    <v-card>
                        <v-card-title>
                            <b>New client</b>
                        </v-card-title>
                        <v-card-text class="text--primary">
                            <client-form ref="client-creation-form"
                                         @validation-changed="handleFormValidationChanged"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!createButtonActive" @click="handleCreateButtonClick"
                                   :loading="progress('createClient')">
                                Create
                            </v-btn>
                            <v-btn @click="handleCancelButtonClick">
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapState} from 'vuex'
    import ClientForm from '../Components/ClientForm';

    export default {
        name: "CreateClient",
        components: {
            ClientForm
        },
        data() {
            return {
                breadcrumbs: [
                    {
                        text: 'Clients',
                        disabled: false,
                        href: '#/clients'
                    },
                    {
                        text: 'Create',
                        disabled: true,
                        href: '#/clients/create'
                    }
                ],
                formValid: false
            }
        },
        computed: {
            ...mapState('clients', {
            }),
            ...mapGetters('clients', {
                progress: 'progress'
            }),
            createButtonActive () {
                return this.formValid && !this.progress('createClient')
            }
        },
        mounted() {
            this.formValid = this.$refs['client-creation-form'].isFormValid()
        },
        methods: {
            ...mapActions({
                create: 'clients/createClient'
            }),
            async handleCreateButtonClick () {
                const formData = this.$refs['client-creation-form'].getFormData()
                const creationResult = await this.create(formData)

                if (!creationResult) {
                    return
                }

                this.$refs['client-creation-form'].reset()
                this.$router.push('/clients')
            },
            handleCancelButtonClick () {
                this.$refs['client-creation-form'].reset()
                this.$router.push('/clients')
            },
            handleFormValidationChanged (value) {
                this.formValid = value
            }
        }
    }
</script>

<style scoped>

</style>